module.exports = __webpack_public_path__ + "img/eye.2b59b673.svg";